import { get, set } from '@/helper/localStorage'
import _get from 'lodash/get'
import fields from '@/field/table/voucher-usage'

export default {
  namespaced: true,
  state: {
    tableFields: get('voucherUsageV2TableFields', fields),
    tableData: [],
    tablePagination: get('voucherUsageV2TablePagination'),
    tableKeyword: get('voucherUsageV2TableKeyword'),
    tableSort: get('voucherUsageV2TableSort'),
    tableFilter: get('voucherUsageV2TableFilter', []),
    detailData: get('voucherUsageV2DetailData'),
    voucherData: null,
    loadingTable: false,
    loadingDetail: false,
    loadingSubmit: false,
    loadingVoucher: false,
  },
  getters: {
    tableFields: state => {
      if (!state.tableFields) {
        return undefined
      }

      // only the visibility is customizable by the user
      const visibilities = state.tableFields.reduce(
        (obj, item) => Object.assign(obj, { [item.key]: item.visibility }), {},
      )

      // the other props uses the default fields configuration
      return fields.map(item => ({
        ...item,
        // only replace the visibility value if user override it
        visibility: item.key in visibilities ? visibilities[item.key] : item.visibility,
      }))
    },
    tableSort: state => {
      if (!state.tableSort) {
        return undefined
      }

      const symbol = state.tableSort.direction === 'desc' ? '-' : ''

      return `${symbol}${state.tableSort.key}`
    },
    tableData: state => {
      if (!state.tableData) {
        return []
      }

      return state.tableData.map(item => ({
        ...item,
        // add or replace field here
      }))
    },
    detailData: state => {
      if (!state.detailData) {
        return undefined
      }

      return {
        ...state.detailData,
        // add or replace field here
      }
    },
    tableFilter: state => {
      if (!state.tableFilter) {
        return []
      }

      return state.tableFilter
        .reduce((acc, elem) => Object.assign(acc, {
          [`filter[${elem.key}]`]: Array.isArray(elem.value)
            ? elem.value.join(',')
            : elem.value,
        }), {})
    },
    tableParams: (state, getters, rootState) => ({
      'filter[keyword]': state.tableKeyword,
      ...getters.tableFilter,
      sort: getters.tableSort,
      page: _get(state, 'tablePagination.current_page', 1),
      limit: rootState.appConfig.settings.tablePerPage,
    }),
  },
  mutations: {
    SET_TABLE_FIELDS(state, val) {
      set('voucherUsageV2TableFields', val)
      state.tableFields = val
    },
    RESET_TABLE_FIELDS(state) {
      set('voucherUsageV2TableFields', fields)
      state.tableFields = fields
    },
    SET_TABLE_DATA(state, val) {
      state.tableData = val
    },
    SET_TABLE_PAGINATION(state, val) {
      set('voucherUsageV2TablePagination', val)
      state.tablePagination = val
    },
    SET_TABLE_KEYWORD(state, val) {
      set('voucherUsageV2TableKeyword', val)
      state.tableKeyword = val
    },
    SET_DETAIL_DATA(state, val) {
      set('voucherUsageV2DetailData', val)
      state.detailData = val
    },
    SET_TABLE_SORT(state, val) {
      set('voucherUsageV2TableSort', val)
      state.tableSort = val
    },
    SET_TABLE_FILTER(state, val) {
      set('voucherUsageV2TableFilter', val)
      state.tableFilter = val
    },
    SET_LOADING_TABLE(state, val) {
      state.loadingTable = val
    },
    SET_LOADING_DETAIL(state, val) {
      state.loadingDetail = val
    },
    SET_LOADING_SUBMIT(state, val) {
      state.loadingSubmit = val
    },
    SET_VOUCHER_DATA(state, val) {
      state.voucherData = val
    },
    SET_LOADING_VOUCHER(state, val) {
      state.loadingVoucher = val
    },
  },
  actions: {
    getTableData({ commit, getters, state }, voucherId) {
      commit('SET_LOADING_TABLE', true)

      const voucherIdParam = voucherId
        || getters.tableFilter['filter[voucher_id]']
        || state.tableFilter.find(f => f.key === 'voucher_id')?.value
        || this._vm.$route.params.id

      const { tableParams: params } = getters
      if (!voucherIdParam) {
        commit('SET_TABLE_DATA', [])
        commit('SET_TABLE_PAGINATION', {})
        commit('SET_LOADING_TABLE', false)
        return
      }
      this._vm.$http.get(`/v1/admin/vouchers/${voucherIdParam}/transactions`, { params })
        .then(({ data }) => {
          commit('SET_TABLE_DATA', data.data)
          commit('SET_TABLE_PAGINATION', data.meta)
        })
        .finally(() => {
          commit('SET_LOADING_TABLE', false)
        })
    },
    search(_, payload) {
      const voucherId = payload?.voucherId || this._vm.$route.params.id
      if (!voucherId) return Promise.resolve([])
      return this._vm.$http.get(`/v1/admin/vouchers/${voucherId}/transactions`, {
        params: {
          'filter[ids]': payload?.ids,
          'filter[keyword]': payload?.keyword,
        },
      })
        .then(({ data }) => data.data)
        .catch(() => [])
    },
    getVoucherDetail({ commit }, id) {
      commit('SET_LOADING_VOUCHER', true)

      const voucherIdParam = id || this._vm.$route.params.id
      if (!voucherIdParam) {
        commit('SET_VOUCHER_DATA', null)
        commit('SET_LOADING_VOUCHER', false)
        return Promise.resolve(null)
      }

      return this._vm.$http.get(`/v2/admin/vouchers/${voucherIdParam}`)
        .then(({ data }) => {
          commit('SET_VOUCHER_DATA', data.data)
          return data.data
        })
        .catch(() => {
          commit('SET_VOUCHER_DATA', null)
          return null
        })
        .finally(() => {
          commit('SET_LOADING_VOUCHER', false)
        })
    },
  },
}
